module.exports = __webpack_public_path__ + "static/media/Intransit truck 1.25548af3.svg";